import { Icon } from '@aptuno/aptuno-ui';
import { FC } from 'react';
import DateTimePicker from 'react-date-picker/dist/entry.nostyle';
import { DatePickerContainer } from './DatePicker.styled';

type DateInputProps = React.ComponentProps<typeof DateTimePicker> & {
  invalid?: boolean;
};
export const DateInput: FC<DateInputProps> = (props) => {
  return (
    <>
      <DatePickerContainer invalid={!!props.invalid}>
        <DateTimePicker format={'dd/MM/yyyy'} {...props} calendarIcon={<Icon icon="calendar" color="#6C757D" />} />
      </DatePickerContainer>
    </>
  );
};
